export function confirmationCodeSentMessage(userPrefersVoiceCalls: boolean, userHitTimeLimit?: boolean) {
	const limitText = userHitTimeLimit ? 'The time limit has expired. ': '';
	return userPrefersVoiceCalls
		? `${limitText}We'll call you with a 6-digit security code.`
		: `${limitText}We've sent a text message to your mobile with a 6-digit security code.`;
}
